module.exports = __webpack_public_path__ + "Flag-752.f3e8de52ddcb1835de44d6d34fe2b599.svg";